module.exports = __webpack_public_path__ + "img/car-bg.6c4751f3.png";